import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircleIcon, SendIcon, PhoneIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ThankYouPage() {
  const orderNumber = Math.floor(10000 + Math.random() * 90000);
  return <main className="min-h-screen bg-slate-50 flex items-center justify-center py-16" data-id="element-1139">
      <div className="max-w-lg mx-auto px-4 text-center" data-id="element-1140">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15
      }} className="w-24 h-24 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-1141">
          <CheckCircleIcon className="w-14 h-14 text-emerald-500" data-id="element-1142" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} data-id="element-1143">
          <h1 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-1144">
            Дякуємо за замовлення!
          </h1>
          <p className="text-lg text-slate-600 mb-2" data-id="element-1145">
            Ваше замовлення №{orderNumber} успішно оформлено
          </p>
          <p className="text-slate-500 mb-8" data-id="element-1146">
            Ми зв'яжемося з вами найближчим часом для підтвердження
          </p>

          <div className="bg-white rounded-2xl shadow-md p-6 mb-8" data-id="element-1147">
            <h2 className="font-semibold text-slate-900 mb-4" data-id="element-1148">Що далі?</h2>
            <ul className="text-left space-y-3 text-slate-600" data-id="element-1149">
              <li className="flex items-start gap-3" data-id="element-1150">
                <span className="w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center text-sm font-medium flex-shrink-0" data-id="element-1151">
                  1
                </span>
                <span data-id="element-1152">
                  Наш менеджер зателефонує для підтвердження замовлення
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1153">
                <span className="w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center text-sm font-medium flex-shrink-0" data-id="element-1154">
                  2
                </span>
                <span data-id="element-1155">Ви отримаєте SMS з номером ТТН після відправлення</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1156">
                <span className="w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center text-sm font-medium flex-shrink-0" data-id="element-1157">
                  3
                </span>
                <span data-id="element-1158">Заберіть замовлення у відділенні Нової Пошти</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" data-id="element-1159">
            <a href="https://t.me/aquapools_if" target="_blank" rel="noopener noreferrer" data-id="element-1160">
              <Button variant="outline" leftIcon={<SendIcon className="w-5 h-5" data-id="element-1162" />} className="w-full sm:w-auto" data-id="element-1161">
                Написати в Telegram
              </Button>
            </a>
            <a href="tel:+380671234567" data-id="element-1163">
              <Button variant="outline" leftIcon={<PhoneIcon className="w-5 h-5" data-id="element-1165" />} className="w-full sm:w-auto" data-id="element-1164">
                Зателефонувати
              </Button>
            </a>
          </div>

          <Link to="/" data-id="element-1166">
            <Button size="lg" rightIcon={<ArrowRightIcon className="w-5 h-5" data-id="element-1168" />} data-id="element-1167">
              Повернутися на головну
            </Button>
          </Link>
        </motion.div>
      </div>
    </main>;
}